import axios from 'axios' 
import { BUSCAR_REPASSE_VENDA_SITE } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';
import moment from 'moment';
import { tipoRepasseVenda } from '../../util/constantsUtil';
import { abaRepasseVenda } from '../../util/constantsUtil';

export default function buscarRepasseVendaSite (dataInicio, dataFim, tipo = tipoRepasseVenda.empresa.nome, aba = abaRepasseVenda.pendenteRepasse) {

  let url = `${URL}/repasse-venda/site?aba=${aba}`;

  if(tipo != null) {
    url = `${url}&tipo=${tipo}`
  }

  if (dataInicio != null && dataFim != null) {
    url = `${URL}/repasse-venda/site?dataInicio=${moment(dataInicio)
      .format('YYYY-MM-DD')}&dataFim=${moment(dataFim)
      .format('YYYY-MM-DD')}&tipo=${tipo}&aba=${aba}`;    
  }
    
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_REPASSE_VENDA_SITE,
        payload: response
      })
  );
}
